import React, { Component } from 'react'
import classnames from 'classnames'

import {
  getSalesInformations,
  getCarriedSalesInformations
} from '../../services/api'
import { constructError } from '../../services/errors.js'

import memoize from 'lodash.memoize'

import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import IconButton from '@material-ui/core/IconButton'
import RemoveIcon from '@material-ui/icons/Remove'

import './ProductSalesInformations.css'

export default class ProductSalesInformations extends Component {
  state = {
    newid: -1
  }
  getIds = productOptions =>
    productOptions !== undefined
      ? productOptions.map(option => option.optionId).filter(id => id !== '')
      : []

  carriedSalesInformations = memoize((productIds, merchantCode) =>
    getCarriedSalesInformations(merchantCode, productIds)
  )

  async componentDidMount() {
    const { productOptions, merchantCode } = this.props
    const salesInformations = await getSalesInformations(merchantCode)
    const carriedSalesInformations = await this.carriedSalesInformations(
      this.getIds(productOptions),
      merchantCode
    )
    this.setState({ salesInformations, carriedSalesInformations })
  }

  async componentDidUpdate(prevProps, prevState) {
    const { productOptions, merchantCode, deleteMultiple } = this.props
    if (prevProps.productOptions !== productOptions) {
      const carriedSalesInformations = await this.carriedSalesInformations(
        this.getIds(productOptions),
        merchantCode
      )
      this.setState({ carriedSalesInformations }, () => {
        const idAlreadyCarried = this.props.productSalesInformations
          .filter(si =>
            carriedSalesInformations.some(
              c => c.salesInformationId === si.salesInformationId
            )
          )
          .map(filtered => filtered.id)
        deleteMultiple(idAlreadyCarried)
      })
    }
  }

  selectChange = (id, name) => e => {
    this.props.changeSalesInformation(id, name, e.target.value)
  }
  checkboxChange = (id, name) => e => {
    this.props.changeSalesInformation(id, name, e.target.checked)
  }
  addSalesInformation = () => {
    this.props.addSalesInformation(this.state.newid)
    this.setState(state => ({ newid: state.newid - 1 }))
  }
  renderSalesInformation(productSalesInformation, index, isCarried, error) {
    const { salesInformations, carriedSalesInformations } = this.state
    const { productSalesInformations, deleteSalesInformation } = this.props

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        item
        xs={12}
        spacing={16}
        key={productSalesInformation.id}
        className={classnames({
          'sp-productsalesinformations--carried': isCarried
        })}
      >
        <Grid item sm={2}>
          <FormControl margin="normal">
            {isCarried ? (
              <span className="sp-productsalesinformations--carriedsource">
                {productSalesInformation.productName}
              </span>
            ) : (
              <IconButton
                onClick={deleteSalesInformation(productSalesInformation.id)}
              >
                <RemoveIcon />
              </IconButton>
            )}
          </FormControl>
        </Grid>
        <Grid item sm={5} xs={7}>
          <FormControl
            fullWidth
            margin="normal"
            disabled={isCarried}
            error={error !== undefined}
          >
            <InputLabel htmlFor="valeur">Valeur {index}</InputLabel>
            <Select
              value={productSalesInformation.salesInformationId}
              onChange={this.selectChange(
                productSalesInformation.id,
                'salesInformationId'
              )}
              inputProps={{ id: 'valeur' }}
            >
              <MenuItem value="">
                <em>Sélectionnez une valeur...</em>
              </MenuItem>
              {salesInformations.map(salesInformation => (
                <MenuItem
                  value={salesInformation.id}
                  key={salesInformation.id}
                  disabled={[
                    ...carriedSalesInformations,
                    ...productSalesInformations
                  ].some(si => si.salesInformationId === salesInformation.id)}
                >
                  {salesInformation.value.technicalLabel}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {error && constructError(error['salesInformationId'])}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item sm={3}>
          <FormControl margin="normal" disabled={isCarried}>
            <FormControlLabel
              margin="normal"
              control={
                <Checkbox
                  checked={productSalesInformation.mandatory}
                  onChange={this.checkboxChange(
                    productSalesInformation.id,
                    'mandatory'
                  )}
                  value="mandatory"
                  color="secondary"
                />
              }
              label="Obligatoire"
            />
          </FormControl>
        </Grid>
      </Grid>
    )
  }
  render() {
    const { salesInformations, carriedSalesInformations } = this.state
    const { productSalesInformations } = this.props
    const { errors } = this.props
    return salesInformations !== undefined ? (
      <Grid container spacing={16} justify="center">
        {carriedSalesInformations &&
          carriedSalesInformations.map((carriedSalesInformation, index) =>
            this.renderSalesInformation(
              carriedSalesInformation,
              index + 1,
              true
            )
          )}
        {productSalesInformations &&
          productSalesInformations.map((productSalesInformation, index) =>
            this.renderSalesInformation(
              productSalesInformation,
              index + 1 + carriedSalesInformations.length,
              false,
              errors && errors.elements[index]
            )
          )}
        <Button
          className="sp-productsalesinformations--actions"
          variant="contained"
          color="default"
          onClick={this.addSalesInformation}
        >
          Ajouter une valeur
        </Button>
      </Grid>
    ) : (
      <div>Pas de valeur</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/products/ProductSalesInformations.js